import { Box, styled } from '@mui/system';
import { TableCell } from '@mui/material';
import { Key as KeyIcon } from '@mui/icons-material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3)
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3)
}));

export const HeaderLeft = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const EmptyStateCell = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4)
}));

export const EmptyStateIcon = styled(KeyIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2)
}));

export const ExpireContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(1)
}));

export const APIKeyCell = styled(TableCell)(() => ({
  fontFamily: 'monospace'
}));

export const LabelCell = styled(TableCell)(() => ({
  maxWidth: 200,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));
